module.exports = __webpack_public_path__ + "static/media/bk.10465dfe.png";